import script from "./EditContentPath.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditContentPath.vue?vue&type=script&lang=ts&setup=true"

import "./EditContentPath.vue?vue&type=style&index=0&id=188b01cc&lang=scss"
import "./EditContentPath.vue?vue&type=style&index=1&id=188b01cc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-188b01cc"]])

export default __exports__